import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import site from "@/config/site";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "bg-[#0A0F08]/80 backdrop-blur-xl border-b border-[#27331C]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo">
          <img src="/logo-sanvalio.png" alt="Sanvalio" className="h-8 sm:h-9 w-auto" />
        </Link>
        <div className="flex items-center gap-3">
          <Link
            to="/audit"
            data-testid="nav-audit-link"
            className="hidden sm:inline-block font-mono2 text-[11px] tracking-[0.2em] text-[#8A8C7E] hover:text-[var(--accent)] transition-colors duration-300"
          >
            FREE AUDIT
          </Link>
          <button
            data-testid="nav-book-btn"
            onClick={() => navigate("/book?plan=growth")}
            className="btn-accent group flex items-center gap-2 font-semibold text-xs sm:text-sm px-4 sm:px-6 py-2.5 sm:py-3"
          >
            Book ₹999 Growth Call
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Nav;
